import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../store";
import useMyRank from "../../../utils/useMyRank";

const storageKey = (username) => `levelSeen:${username}`;

// Kullanıcı seviye atladığında bir kez tebrik penceresi gösterir; sayfa değişimlerinde seviyeyi tazeler.
const LevelUpWatcher = ({ refreshKey }) => {
  const username = useAppSelector((state) => state.auth.currentUser?.username);
  const rank = useMyRank(refreshKey);
  const [celebrated, setCelebrated] = useState(null);

  useEffect(() => {
    if (!rank || !username) return;
    let seen = null;
    try {
      seen = Number(localStorage.getItem(storageKey(username))) || null;
      localStorage.setItem(storageKey(username), String(rank.level));
    } catch (e) {}
    if (seen && rank.level > seen) {
      setCelebrated(rank);
      if (typeof window.gtag === "function") {
        window.gtag("event", "level_up", { level: rank.level });
      }
    }
  }, [rank, username]);

  useEffect(() => {
    if (!celebrated) return undefined;
    const onKeyDown = (e) => e.key === "Escape" && setCelebrated(null);
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [celebrated]);

  if (!celebrated) return null;
  const close = () => setCelebrated(null);

  return (
    <div
      onClick={close}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        backgroundColor: "rgba(0,0,0,0.6)",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="level-up-title"
        onClick={(e) => e.stopPropagation()}
        className="dark"
        style={{
          width: "100%",
          maxWidth: 380,
          padding: "32px 24px 24px",
          borderRadius: 20,
          borderTop: `4px solid ${celebrated.color}`,
          textAlign: "center",
          boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ fontSize: 64, lineHeight: 1, marginBottom: 12 }} aria-hidden="true">
          {celebrated.icon}
        </div>
        <h2 id="level-up-title" style={{ margin: "0 0 6px", fontSize: 22, fontWeight: 700, color: "#fff" }}>
          Tebrikler, seviye atladın!
        </h2>
        <p style={{ margin: "0 0 16px", fontSize: 16, fontWeight: 600, color: celebrated.color }}>
          Seviye {celebrated.level} · {celebrated.name}
        </p>
        <p style={{ margin: "0 0 22px", fontSize: 14, lineHeight: 1.6, opacity: 0.75 }}>
          Artık günde <b>{celebrated.daily_messages}</b> mesaj gönderebilirsin.
          {celebrated.next_rank && (
            <>
              {" "}
              Sıradaki hedef: {celebrated.next_rank.icon} <b>{celebrated.next_rank.name}</b> (
              {celebrated.next_rank.points_needed} alkış).
            </>
          )}
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <button type="button" className="btn circle primary p-x-md" onClick={close}>
            Harika!
          </button>
          <Link to="/app/seviyeler" className="btn circle btn-outline b-white p-x-md" onClick={close}>
            Seviyeleri gör
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LevelUpWatcher;
